import { render, staticRenderFns } from "./JSelectJxbByZy.vue?vue&type=template&id=72ba90b0&scoped=true"
import script from "./JSelectJxbByZy.vue?vue&type=script&lang=js"
export * from "./JSelectJxbByZy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ba90b0",
  null
  
)

export default component.exports